import { parseAssetSourceId } from './asset_id';
import type { FundAsset, SerializedFundAsset } from './fund_asset';
import { deserializeFundAsset } from './fund_asset';

export interface AssetProfile {
  id: string;
  sourceId: string;
  name: string;
  funds?: Array<[string, FundAsset]>;
  details?: AssetDetails;
}

export interface AssetDetails {
  name?: string;
  description?: string;
  url?: string;
  sector?: string;
  country?: string;
  industry?: string;
  currency?: string;
  price?: number;
  marketCap?: number;
  timestamp: string;
}

export interface SerializedAssetProfile {
  i: string;
  n: string;
  f?: Array<[string, SerializedFundAsset]>;
  d?: SerializedAssetDetails;
}

export interface SerializedAssetDetails {
  n?: string;
  d?: string;
  u?: string;
  c?: string;
  s?: string;
  i?: string;
  cr?: string;
  p?: number;
  m?: number;
  ts: number;
}

export function deserializeAssetProfile(serializedAssetProfile: SerializedAssetProfile): AssetProfile {
  const profile: AssetProfile = {
    id: parseAssetSourceId(serializedAssetProfile.i),
    sourceId: serializedAssetProfile.i,
    name: serializedAssetProfile.n,
  };

  if (serializedAssetProfile.f) {
    profile.funds = serializedAssetProfile.f.map(([fundIsin, fundAsset]) => [
      fundIsin,
      deserializeFundAsset(fundAsset),
    ]);
  }

  if (serializedAssetProfile.d) {
    profile.details = deserializeAssetDetails(serializedAssetProfile.d);
  }

  return profile;
}

function deserializeAssetDetails(serializedAssetDetails: SerializedAssetDetails): AssetDetails {
  return {
    name: serializedAssetDetails.n,
    description: serializedAssetDetails.d,
    url: serializedAssetDetails.u,
    country: serializedAssetDetails.c,
    industry: serializedAssetDetails.i,
    sector: serializedAssetDetails.s,
    currency: serializedAssetDetails.cr,
    price: serializedAssetDetails.p,
    marketCap: serializedAssetDetails.m,
    timestamp: new Date(serializedAssetDetails.ts).toISOString(),
  };
}
